module.exports = __webpack_public_path__ + "img/狼毒.f44da7b9.jpg";